export const GET_CURRENT_SYSTEM_CONFIGURATION_ADVANCED_SEARCH_ON = {
  advancedSearch: {
    enabled: true,
  },
  distributedCache: {
    enabled: false,
  },
  contentDistributedSystem: {
    enabled: false,
  },
};

export const GET_CURRENT_SYSTEM_CONFIGURATION_ADVANCED_SEARCH_OFF = {
  advancedSearch: {
    enabled: false,
  },
  distributedCache: {
    enabled: false,
  },
  contentDistributedSystem: {
    enabled: false,
  },
};
